import { Modal } from "react-bootstrap";
import ModalHead from "../../../../common/ui/ModalHead";
import *  as CommonUtilities from "../../../../common/utils/CommonUtils.js";
import defaultImage from "../../../../images/default.jpg";
import ErrorAlert from "../../../../common/ui/ErrorAlert";

export default function ItemVoucherChildPage(props) {
    let selectedProductID = props.loyaltyMember.ItemVoucherChildPage.SelectedProduct.ProductID;
    let chargePriceForMods = props.loyaltyMember.ItemVoucherChildPage.SelectedProduct.ChargePriceForMods;
    let formData = props.loyaltyMember.ItemVoucherChildPage.FormData.ModifierCategories;
    let voucherMenuNumber = `voucherMenu${props.loyaltyMember.ItemVoucherProductListPage.SelectedGroup.VoucherMenuNumber}`;
    let groupDetails = props.loyaltyMember.VoucherDetails.OriginalData[voucherMenuNumber][0];
    let productsInGroup = groupDetails.products;

    // Product Details
    let productDetails = productsInGroup.find(({productID}) => productID == selectedProductID);

    // Is Disabled
    let isDisabled = props.loyaltyMember.ItemVoucherChildPage.GeneralError.ButtonsDisabled || !props.currentLocation.AllowOnlineOrder || !props.currentLocation.Validation.IsValidTableNumber;
    let isDisabledCursor = isDisabled ? "default" : "pointer";

    // Energy Count
    let energyCount;
    if (productDetails.energyCount !== 0 && productDetails.energyCount !== "0" && productDetails.energyCount !== "" && productDetails.energyCount !== null) {
        energyCount = <span className="wo-pm__kj">{productDetails.energyCount}kJ</span>
    } else {
        energyCount = <></>
    }

    const hasOptions = (productDetails.modeCategories || []).length > 0;

    // Modifier Categories
    let modifierCategories, modifiers;
    modifierCategories = productDetails.modeCategories?.map((modCat) => {

        // Choose Amount - Text
        let badgeClassStyles = "";
        let chooseAmountText = "";
        if (modCat.minValue == 0) {
            chooseAmountText = `Choose up to ${modCat.maxValue}`
        } else if (modCat.minValue == modCat.maxValue) {
            chooseAmountText = `Choose ${modCat.maxValue}`
        } else {
            chooseAmountText = `Choose between ${modCat.minValue} - ${modCat.maxValue}`
        }

        // Modifiers
        modifiers = modCat.mods?.map((mod, index) => {
            let modifierPriceInc = chargePriceForMods ? CommonUtilities.formatDisplayPrice(mod.priceInc) : '';
            let modifierLabel;
            let priceLabel;
            let modifierSelector;
            
            if (modCat.type === "Check") { // Check
                // Find Modifier Category
                let formDataModCat = formData.find((modCatFieldName) => modCatFieldName.ModCatFieldName == `CheckModCatId${modCat.modCategoryID}`);
                // Badge for Choose Text
                if (formDataModCat.HasError) {
                    badgeClassStyles = "wo-req--bad";
                } else {
                    badgeClassStyles = "";
                }
                // Form Data - Check
                let modFormData = formDataModCat.Mods.find((modFieldName) => modFieldName.ModFieldName == `CheckModCatId${modCat.modCategoryID}ModId${mod.modID}`);
                // Label, Price and Selector
                modifierLabel = <label className="form-check-label col" htmlFor={`CheckModCatId${modCat.modCategoryID}ModId${mod.modID}`} style={{cursor: isDisabledCursor}}>{mod.modName}</label>
                priceLabel = <label className="ms-1 me-4 form-check-label" htmlFor={`CheckModCatId${modCat.modCategoryID}ModId${mod.modID}`} style={{cursor: isDisabledCursor}}>{modifierPriceInc}</label>
                modifierSelector = <div className="form-check ms-1">
                                        <input className="form-check-input" type="checkbox" value="" data-modplu={mod.modPLUNumberInt} data-priceinc={mod.priceInc} data-modcat={`CheckModCatId${modCat.modCategoryID}`} data-modname={mod.modName} name={`CheckModCatId${modCat.modCategoryID}ModId${mod.modID}`} id={`CheckModCatId${modCat.modCategoryID}ModId${mod.modID}`} checked={modFormData[`CheckModCatId${modCat.modCategoryID}ModId${mod.modID}`]} onChange={props.handleModChangeItemVoucherChild} disabled={isDisabled} style={{cursor: isDisabledCursor}} />
                                    </div>
            } else if (modCat.type === "Radio") { // Radio
                // Find Modifier Category
                let formDataModCat = formData.find((modCatFieldName) => modCatFieldName.ModCatFieldName == `RadioModCatId${modCat.modCategoryID}`);
                // Badge for Choose Text
                if (formDataModCat.HasError) {
                    badgeClassStyles = "wo-req--bad";
                } else {
                    badgeClassStyles = "";
                }
                // Form Data - Radio
                let modFormData = formDataModCat.Mods.find((modFieldName) => modFieldName.ModFieldName == `RadioModCatId${modCat.modCategoryID}`);
                // Label, Price and Selector
                modifierLabel = <label className="form-check-label col" htmlFor={`RadioModCatId${modCat.modCategoryID}ModId${mod.modID}`} style={{cursor: isDisabledCursor}}>{mod.modName}</label>
                priceLabel = <label className="ms-1 me-4 form-check-label" htmlFor={`RadioModCatId${modCat.modCategoryID}ModId${mod.modID}`} style={{cursor: isDisabledCursor}}>{modifierPriceInc}</label>
                modifierSelector = <div className="form-check ms-1">
                                        <input className="form-check-input" type="radio" value={mod.modID} data-modplu={mod.modPLUNumberInt} data-priceinc={mod.priceInc} data-modcat={`RadioModCatId${modCat.modCategoryID}`} data-modname={mod.modName} name={`RadioModCatId${modCat.modCategoryID}`} id={`RadioModCatId${modCat.modCategoryID}ModId${mod.modID}`} checked={modFormData[`RadioModCatId${modCat.modCategoryID}`] == mod.modID} onChange={props.handleModChangeItemVoucherChild} disabled={isDisabled} style={{cursor: isDisabledCursor}} />
                                    </div>
            }

            return ( // Modifiers
                <div key={mod.modID} className="wo-opt__row">
                    {CommonUtilities.StaticFields.ShowModifierImages ?
                    <div className="wo-opt__thumb">
                        <img src={mod.modImageURL ? mod.modImageURL : defaultImage} alt="" loading="lazy" decoding="async"></img>
                    </div>
                    : <></>}
                    {modifierLabel}
                    <div className="wo-opt__pick">
                        {mod.priceInc != 0 && priceLabel}
                        {modifierSelector}
                    </div>
                </div>
            )
        })

        return ( // Modifier Categories
            <div key={modCat.modCategoryID}>
                <div className="wo-opt__head">
                    <span className="wo-opt__name">{modCat.modCategoryName}</span>
                    {modCat.maxValue && <span className={`wo-req ${badgeClassStyles}`}>{chooseAmountText}</span>}
                </div>
                {modifiers}
            </div>
        )
    })

    return (
        <>
            <ModalHead
                title="Set it up"
                onBack={props.handleBackItemVoucherChild}
                backDisabled={props.loyaltyMember.ItemVoucherChildPage.GeneralError.ButtonsDisabled}
                onClose={props.handleClickCloseLoyaltyModal}
            />
            <Modal.Body className="wo-pm__body">
                {/* Compact header when there are modifiers, same as the product
                    screens — the photo must not bury the choices. */}
                {productDetails.productImageURL && !hasOptions &&
                    <div className="wo-pm__hero">
                        <img src={productDetails.productImageURL} alt={productDetails.productDisplayName}
                             loading="lazy" decoding="async" />
                    </div>}
                <div className={`wo-pm__intro${hasOptions ? ' wo-pm__intro--compact' : ''}`}>
                    {productDetails.productImageURL && hasOptions &&
                        <span className="wo-pm__thumb">
                            <img src={productDetails.productImageURL} alt={productDetails.productDisplayName}
                                 loading="lazy" decoding="async" />
                        </span>}
                    <div className="wo-pm__introText">
                        <div className="wo-pm__nameRow">
                            <h3 className="wo-pm__name">{productDetails.productDisplayName}</h3>
                            {energyCount}
                        </div>
                    </div>
                </div>
                <div className="wo-pm__options">
                    {modifierCategories}
                </div>
            </Modal.Body>
            <Modal.Footer className="wo-pm__foot">
                { props.loyaltyMember.ItemVoucherChildPage.GeneralError.HasError && <div className="wo-pm__footErr"><ErrorAlert message={props.loyaltyMember.ItemVoucherChildPage.GeneralError.ErrorMessage} /></div> }
                    {props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber &&
                    <div className="wo-pm__footBar">
                        <button type="button" className="wo-pm__add" onClick={props.handleAddToVoucherItemVoucherChild} disabled={props.loyaltyMember.ItemVoucherChildPage.GeneralError.ButtonsDisabled} >
                            Add to Voucher
                            { props.loyaltyMember.ItemVoucherChildPage.GeneralError.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></>}
                        </button>
                    </div>}
            </Modal.Footer>
        </>
    )
}